import _ from 'lodash'
import envConfig from '../../../next-server/lib/runtime-config'
const Sentry = process.browser
  ? require('@sentry/browser')
  : require('@sentry/node')

export { Sentry }

export function isSentryEnabled() {
  return !!_.get(
    envConfig(),
    'publicRuntimeConfig.frameworkConfig.sentry.enabled'
  )
}

export const customSentryReportIfEnabled = (
  errorOrMessage = '',
  businessName = '',
  settingContext = (scope) => {}
) => {
  // 检测sentry是否可用
  const isEnable = isSentryEnabled()
  isEnable &&
    Sentry.withScope((scope) => {
      // 支持设置上下文，tag/extras/user...
      settingContext(scope)

      // 通过打tag 区分自定义与自动上报的真实错误
      scope.setTag('fw_isBusiness', true)
      scope.setTag('fw_businessName', businessName)
      if (errorOrMessage instanceof Error) {
        Sentry.captureException(errorOrMessage)
      } else if (typeof errorOrMessage === 'string') {
        Sentry.captureMessage(errorOrMessage)
      } else {
        Sentry.captureMessage(errorOrMessage.toString())
      }
    })
}
